import "core-js/modules/web.dom.iterable";
export var callAll = function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn && fn.apply(void 0, args);
    });
  };
};
export function compose() {
  switch (arguments.length) {
    case 1:
      return _compose1(arguments[0]);

    case 2:
      return _compose2(arguments[0], arguments[1]);

    case 3:
      return _compose3(arguments[0], arguments[1], arguments[2]);

    case 4:
      return _compose4(arguments[0], arguments[1], arguments[2], arguments[3]);

    case 5:
      return _compose5(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
  }
}

function _compose1(f) {
  return function compose1Fn(a) {
    return f(a);
  };
}

function _compose2(g, f) {
  return function compose2Fn(a) {
    return g(f(a));
  };
}

function _compose3(h, g, f) {
  return function compose3Fn(a) {
    return h(g(f(a)));
  };
}

function _compose4(i, h, g, f) {
  return function compose3Fn(a) {
    return i(h(g(f(a))));
  };
}

function _compose5(j, i, h, g, f) {
  return function compose5Fn(a) {
    return j(i(h(g(f(a)))));
  };
}